import {Box, Center, Spinner, Text, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';

export function ClassifiedsMapSkeleton() {
  return (
    <Box height="100%" backgroundColor="palettes.neutral.20.100" role="status">
      <Center height="100%">
        <VStack spacing={4} align="center">
          <Spinner />
          <Text color="secondary">{i18n.t('page.sourcing.map.loading')}</Text>
        </VStack>
      </Center>
    </Box>
  );
}
